module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./indexView.js"));
	}, "OpenEcardView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=OpenEcardView!./src/pages/Shop/Member/Wallet/BankCard/OpenEcard/indexView.js
// module id = 1999
// module chunks = 367